export default __webpack_public_path__ + "static/regular-cabin-kitchen-2ee96f87c2156a78cbb998042d88d6c3.jpg";